export default "/kiban/_next/static/images/referFriendsCouponBannerWide-a5c3a54cd0e6584bf2ae605c71dc47e9.png";